module.exports = __webpack_public_path__ + "img/home_list_2.6e786561.png";